import { useParams, useNavigate } from "react-router-dom";
import { Box, Typography, Card, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import ArrowBackIosNew from "@mui/icons-material/ArrowBackIosNew";
import { TESTING_SESSIONS } from "@/data/mock-data";
import { formatPct } from "@/lib/formatters";

export function TestingSessionPage() {
  const { sessionId } = useParams();
  const navigate = useNavigate();
  const s = TESTING_SESSIONS.find((t) => t.id === sessionId);

  if (!s) return <Typography textAlign="center" py={6}>Session not found.</Typography>;

  return (
    <Box sx={{ maxWidth: 960, mx: "auto" }}>
      <Button startIcon={<ArrowBackIosNew sx={{ fontSize: 14 }} />} onClick={() => navigate("/testing")} sx={{ mb: 2 }}>
        Testing
      </Button>
      <Card sx={{ p: 3, mb: 2 }}>
        <Typography variant="overline" color="text.secondary">Backtest</Typography>
        <Typography variant="h2" sx={{ mb: 0.5 }}>{s.botName}</Typography>
        <Typography variant="body2" color="text.secondary">
          Started {s.startedAt} · Portfolio {s.portfolio}
        </Typography>
      </Card>

      <Grid container spacing={1.5}>
        <Stat label="Return" value={formatPct(s.return)} color={s.return >= 0 ? "primary.main" : "error.main"} />
        <Stat label="Win Rate" value={formatPct(s.winRate, { signed: false })} />
        <Stat label="Trades" value={String(s.trades)} />
        <Stat label="Notes" value={s.notes} />
      </Grid>

      <Card sx={{ p: 3, mt: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Full equity curve, drawdown chart, trade-by-trade log, and stats (CAGR, Sharpe, Sortino, Calmar) render here when this page is fleshed out.
        </Typography>
      </Card>
    </Box>
  );
}

function Stat({ label, value, color }: { label: string; value: string; color?: string }) {
  return (
    <Grid size={{ xs: 6, sm: 3 }}>
      <Card sx={{ p: 2 }}>
        <Typography variant="caption" color="text.secondary">{label}</Typography>
        <Typography variant="h5" sx={{ color, fontFeatureSettings: '"tnum" 1', mt: 0.5 }}>{value}</Typography>
      </Card>
    </Grid>
  );
}
